import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { postSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const user = await postSession(sessionId);
        setUser(user);
        // clean hash and go to my-reports
        window.history.replaceState({}, "", "/my-reports");
        navigate("/my-reports", { replace: true, state: { user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center font-mono-plex text-sm" data-testid="auth-callback">
      Authenticating...
    </div>
  );
}
